const listItemData = [
  {
    id: 1,
    listClass: 'nav-item',
    linkHref: 'aboutMe',
    activeClass: 'active',
    linkContent: 'about me'
  },
  {
    id: 2,
    listClass: 'nav-item',
    linkHref: 'certificates',
    linkContent: 'certificates'
  },
  {
    id: 3,
    listClass: 'nav-item',
    linkHref: 'skills',
    linkContent: 'my skills'
  },
  {
    id: 4,
    listClass: 'nav-item',
    linkHref: 'portfolio',
    linkContent: 'portfolio'
  },
  {
    id: 5,
    listClass: 'nav-item',
    linkHref: 'contactMe',
    linkContent: 'contact me'
  },
]

export default listItemData;